module.exports = __webpack_public_path__ + "static/media/social_media_circle.8b098c3e.png";